import React from "react";
import { Link } from "react-router-dom";
import { X, ShoppingBag } from "lucide-react";
import { money } from "../lib/api";
import { useCjCart } from "../context/CjCartContext";
import { toast } from "sonner";

export const QuickView = ({ product, onClose }) => {
  const { add } = useCjCart();
  if (!product) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" data-testid="quick-view-modal">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative bg-white max-w-3xl w-full grid sm:grid-cols-2 max-h-[90vh] overflow-y-auto">
        <button onClick={onClose} data-testid="quick-view-close" className="absolute top-3 right-3 z-10 p-2 bg-white/90 hover:bg-black hover:text-white"><X className="w-5 h-5" /></button>
        <div className="aspect-square bg-taven-gray">
          {product.image && <img src={product.image} alt={product.title} className="w-full h-full object-cover" />}
        </div>
        <div className="p-6 flex flex-col">
          {product.onSale && <span className="self-start bg-taven-red text-white text-[10px] font-bold uppercase tracking-wider px-2 py-1 mb-3">Sale</span>}
          <h3 className="text-xl font-black font-display">{product.title}</h3>
          <div className="flex items-baseline gap-2 mt-3">
            <span className="text-2xl font-black">{money(product.price, product.currency)}</span>
            {product.compareAtPrice && <span className="text-sm text-gray-400 line-through">{money(product.compareAtPrice, product.currency)}</span>}
          </div>
          <p className="text-sm text-muted-foreground mt-4 line-clamp-4 flex-grow">{product.description}</p>
          <div className="flex gap-2 mt-6">
            <button onClick={() => { add(product, 1, "shopify"); toast.success("Added to cart"); onClose(); }} data-testid="quick-view-add" className="flex-1 bg-taven-black text-white font-bold uppercase tracking-wider py-3 hover:bg-taven-orange transition-colors flex items-center justify-center gap-2"><ShoppingBag className="w-4 h-4" /> Add to Cart</button>
            <Link to={`/product/${product.handle}`} onClick={onClose} className="flex-1 border border-black text-black font-bold uppercase tracking-wider py-3 text-center hover:bg-black hover:text-white transition-colors">View Details</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickView;
